
/*
 * Quantellia qlib.js
 *
 * Copyright (c) 2016 - 2025 Quantellia LLC
 * 
 *  All Rights Reserved.
 * 
 * NOTICE:  All source code, data, and any other information contained 
 * in this file is, and remains the property of Quantellia LLC.
 * The intellectual and technical concepts contained
 * herein are proprietary to Quantellia LLC and may be covered by
 * U.S. and Foreign Patents, patents in process, and are protected 
 * by trade secret or copyright law. Dissemination of this information 
 * or reproduction of this material is strictly forbidden unless 
 * prior written permission is obtained from Quantellia LLC.
 * 
 * The above notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 *
 */

/**
 * GUID generator.  Sourced from https://stackoverflow.com/questions/1320568/best-way-to-generate-unique-ids-client-side-with-javascript
 * @returns A GUID string.
 */
export function createGUID() {
    // RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
    // pseudo-random numbers.
    // The algorithm is as follows:
    //     Set the two most significant bits (bits 6 and 7) of the
    //        clock_seq_hi_and_reserved to zero and one, respectively.
    //     Set the four most significant bits (bits 12 through 15) of the
    //        time_hi_and_version field to the 4-bit version number from
    //        Section 4.1.3. Version4 
    //     Set all the other bits to randomly (or pseudo-randomly) chosen
    //     values.
    // UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
    // time-low               = 4hexOctet
    // time-mid               = 2hexOctet
    // time-high-and-version  = 2hexOctet
    // clock-seq-and-reserved = hexOctet: 
    // clock-seq-low          = hexOctet
    // node                   = 6hexOctet
    // Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    // y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
    // y values are 8, 9, A, B
    var guidHolder = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    var hex = '0123456789abcdef';
    var r = 0;
    var guidResponse = "";
    for (var i = 0; i < 36; i++) {
        if (guidHolder[i] !== '-' && guidHolder[i] !== '4') {
            // each x and y needs to be random
            r = Math.random() * 16 | 0;
        }

        if (guidHolder[i] === 'x') {
            guidResponse += hex[r];
        } else if (guidHolder[i] === 'y') {
            // clock-seq-and-reserved first hex is filtered and remaining hex values are random
            r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
            r |= 0x8; // set pos 3 to 1 as 1???
            guidResponse += hex[r];
        } else {
            guidResponse += guidHolder[i];
        }
    }

    return guidResponse;
}


/**
 * Creates and sends an XMLHTTP request and installs a handler for receiving the results.
 * @param {string} url  The URL to which the request is to be sent.
 * @param {string} data Data included in the request
 * @param {string} responseHandler  Function that will handle the asynchronous response
 * @param {string} method HTTP method (GET, POST, ADD, PUT, etc.)
 * @param {string} params Parameters used by the 
 */
export function ajaxRequest (url, data, responseHandler, method, params) {
        //
        // Assume default method is POST
        //
        if (method == null)
            method = "POST";

        //
        // Create the new AJAX request object
        //
        var xmlhttp = new XMLHttpRequest();

        if (responseHandler != null) {
            xmlhttp.onreadystatechange = function () {
                 if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                    responseHandler(xmlhttp.responseText);
                }
            }
        }

        xmlhttp.open(method, url, true);

        //
        // If the data was supplied as a text string, send it as MIME type urlencoded form data
        // and set appropriate headers
        //
        if (data && (typeof (data)).toLowerCase() == 'string') {
            xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            //xmlhttp.setRequestHeader("Content-length", data.length);
            xmlhttp.setRequestHeader("X-Requested-With", "XmlHttpRequest");
            //xmlhttp.setRequestHeader("Connection", "close");
        }

        //
        // Note - if data is not a string, assume it is of type FormData, in which 
        // case the send(data) call will take care of formatting the HTTP request correctly
        //

        if (params != null) {
            for (p in params)
                xmlhttp[p] = params[p];
        }

        xmlhttp.send(data);
    }